module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_nora-3eab7f8f7ea9b040a4db289ce9157cd5.png";